import { lazy, Suspense } from 'react'
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import { Toaster } from 'react-hot-toast'
import { CartProvider } from './contexts/CartContext'
import { EditModeProvider } from './contexts/EditModeContext'
import { FontThemeProvider } from './contexts/FontThemeContext'
import { TextStyleProvider } from './contexts/TextStyleContext'
import CartDrawer from './components/CartDrawer'
import EditModeFAB from './components/EditModeFAB'
import Header from './components/Header'
import Footer from './components/Footer'
import TopBanner from './components/TopBanner'
import CookieBanner from './components/CookieBanner'
import Home from './pages/Home'

// Code-splitting par route : seule la page d'accueil (Home) est chargee
// immediatement afin de reduire le JS initial telecharge/execute (LCP/FID).
// Toutes les autres pages sont chargees a la demande via React.lazy.
const Gallery = lazy(() => import('./pages/Gallery'))
const Universe = lazy(() => import('./pages/Universe'))
const Artwork = lazy(() => import('./pages/Artwork'))
const About = lazy(() => import('./pages/About'))
const Contact = lazy(() => import('./pages/Contact'))
const AdminNew = lazy(() => import('./pages/AdminNew'))
const AdminUpdates = lazy(() => import('./pages/AdminUpdates'))
const ShippingPolicies = lazy(() => import('./pages/ShippingPolicies'))
const Actualites = lazy(() => import('./pages/Actualites'))
const Press = lazy(() => import('./pages/Press'))
const Cart = lazy(() => import('./pages/Cart'))
const PaymentSuccess = lazy(() => import('./pages/PaymentSuccess'))
const TermsOfSale = lazy(() => import('./pages/TermsOfSale'))
const LegalNotice = lazy(() => import('./pages/LegalNotice'))
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'))
const TermsOfUse = lazy(() => import('./pages/TermsOfUse'))
const InvitationRegister = lazy(() => import('./pages/InvitationRegister'))

const RouteFallback = () => (
  <div className="min-h-[60vh] flex items-center justify-center bg-[#FAF9F6]">
    <div className="inline-block animate-spin rounded-full h-10 w-10 border-b-2 border-[#722F37]" />
  </div>
)

function App() {
  return (
    <Router>
      <CartProvider>
        <EditModeProvider>
        <FontThemeProvider>
        <TextStyleProvider>
        <div className="min-h-screen bg-[#FAF9F6] text-[#2C2C2C]">
          <TopBanner />
          <Header />
          <main>
            <Suspense fallback={<RouteFallback />}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/gallery" element={<Gallery />} />
                <Route path="/artwork/:id" element={<Artwork />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/payment-success" element={<PaymentSuccess />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/shipping" element={<ShippingPolicies />} />
                <Route path="/terms" element={<TermsOfSale />} />
                <Route path="/legal-notice" element={<LegalNotice />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms-of-use" element={<TermsOfUse />} />
                <Route path="/actualites" element={<Actualites />} />
                <Route path="/events" element={<Navigate to="/actualites" replace />} />
                <Route path="/press" element={<Press />} />
                <Route path="/invitation/:eventId" element={<InvitationRegister />} />
                <Route path="/admin" element={<AdminNew />} />
                <Route path="/admin/evolutions" element={<AdminUpdates />} />
              </Routes>
            </Suspense>
          </main>
          <Footer />
          <CartDrawer />
          <EditModeFAB />
          <CookieBanner />
          <Toaster position="bottom-right" />
        </div>
        </TextStyleProvider>
        </FontThemeProvider>
        </EditModeProvider>
      </CartProvider>
    </Router>
  )
}

export default App
